export function addressToColor(address: string, symbol?: string): string {
    if (symbol === "TON") return "#2FAFFF";
    if (symbol === "USDT") return "#24DC77";
    function hashCode(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = (Math.imul(31, hash) + str.charCodeAt(i)) | 0;
        }
        return hash;
    }
    const hash = hashCode(address);
    const r = Math.abs((hash >> 16) % 256);
    const g = Math.abs((hash >> 8) % 256);
    const b = Math.abs(hash % 256);
    return `rgb(${r}, ${g}, ${b})`;
}
